/**
 * @generated SignedSource<<073020bbc5bda620c0da7d753e461c96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferType = "buy" | "rent";
export type PropertyMainType = "AGRI" | "APPT" | "BUILDING" | "COMMERCIAL" | "GARDEN" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "INDUS" | "OTHER" | "PARK" | "PROP" | "ROOM" | "SECONDARY";
export type PropertySearchNotification = "daily" | "never" | "weekly";
export type PropertyStatus = "existing" | "new";
export type PropertyUsage = "investment" | "primary" | "secondary";
export type SubscriptionStatus = "active" | "canceled" | "incomplete" | "incomplete_expired" | "past_due" | "trialing" | "unpaid";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
export type propertySearchDrawerQuery$variables = {
  id: string;
};
export type propertySearchDrawerQuery$data = {
  readonly propertySearch: {
    readonly activateAggregator?: boolean;
    readonly builtSurfaceGte?: number | null;
    readonly builtSurfaceLte?: number | null;
    readonly canEditAlerts?: boolean;
    readonly comment?: string | null;
    readonly hasBalcony?: boolean | null;
    readonly hasGarden?: boolean | null;
    readonly hasLift?: boolean | null;
    readonly hasParking?: boolean | null;
    readonly hasSwimmingPool?: boolean | null;
    readonly hasView?: boolean | null;
    readonly id?: string;
    readonly landSurfaceGte?: number | null;
    readonly landSurfaceLte?: number | null;
    readonly livingSurfaceGte?: number | null;
    readonly livingSurfaceLte?: number | null;
    readonly monthlyRentGte?: number | null;
    readonly monthlyRentLte?: number | null;
    readonly notification?: PropertySearchNotification;
    readonly numberOfBathroomsGte?: number | null;
    readonly numberOfBathroomsLte?: number | null;
    readonly numberOfBedroomsGte?: number | null;
    readonly numberOfBedroomsLte?: number | null;
    readonly numberOfRoomsGte?: number | null;
    readonly numberOfRoomsLte?: number | null;
    readonly offerType?: OfferType;
    readonly places?: ReadonlyArray<{
      readonly breadcrumbs: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly label: string;
      readonly lat: number;
      readonly lng: number;
      readonly objectId: string;
      readonly population: number | null;
      readonly type: TypeOfPlace;
    }> | null;
    readonly propertyMainTypeIn?: ReadonlyArray<PropertyMainType> | null;
    readonly propertyStatuses?: ReadonlyArray<PropertyStatus>;
    readonly propertyTypes?: ReadonlyArray<{
      readonly id: string;
      readonly label: string | null;
      readonly mainType: string | null;
    }> | null;
    readonly propertyUsage?: PropertyUsage | null;
    readonly salePriceGte?: number | null;
    readonly salePriceLte?: number | null;
    readonly source?: string | null;
    readonly user?: {
      readonly firstName: string | null;
      readonly id: string;
      readonly lastName: string | null;
      readonly organisation: {
        readonly formattedAddress: string | null;
        readonly name: string | null;
      } | null;
      readonly primaryEmail: {
        readonly email: string;
      } | null;
      readonly primaryImage: {
        readonly url: string;
      } | null;
      readonly subscription: {
        readonly status: SubscriptionStatus;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"userSummary_user">;
    } | null;
  } | null;
  readonly propertyTypes: ReadonlyArray<{
    readonly id: string;
    readonly label: string | null;
    readonly mainType: string | null;
    readonly name: string | null;
    readonly type: string;
  }> | null;
  readonly tenantSettings: {
    readonly defaultMapCoordinates: {
      readonly lat: number;
      readonly lng: number;
      readonly z: number;
    };
  } | null;
};
export type propertySearchDrawerQuery = {
  response: propertySearchDrawerQuery$data;
  variables: propertySearchDrawerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MapPositionWithZoom",
  "kind": "LinkedField",
  "name": "defaultMapCoordinates",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "z",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "places",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectId",
      "storageKey": null
    },
    (v2/*: any*/),
    (v1/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "population",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "incudeNonIndexed",
          "value": true
        }
      ],
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": "breadcrumbs(incudeNonIndexed:true)"
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePriceLte",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePriceGte",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyRentLte",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyRentGte",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyUsage",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyStatuses",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRoomsGte",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRoomsLte",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBedroomsGte",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBedroomsLte",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathroomsGte",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathroomsLte",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurfaceGte",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurfaceLte",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "builtSurfaceGte",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "builtSurfaceLte",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurfaceGte",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurfaceLte",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainType",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyType",
  "kind": "LinkedField",
  "name": "propertyTypes",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v14/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyMainTypeIn",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSwimmingPool",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLift",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasParking",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasGarden",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBalcony",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasView",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notification",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activateAggregator",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canEditAlerts",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeHidden",
      "value": true
    }
  ],
  "concreteType": "PropertyType",
  "kind": "LinkedField",
  "name": "propertyTypes",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v10/*: any*/),
    (v14/*: any*/),
    (v35/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": "propertyTypes(includeHidden:true)"
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "primaryEmail",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referrer",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBroker",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "propertySearchDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tenant",
        "kind": "LinkedField",
        "name": "tenantSettings",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "propertySearch",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Email",
                    "kind": "LinkedField",
                    "name": "primaryEmail",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryImage",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "organisation",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Subscription",
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "userSummary_user"
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/)
            ],
            "type": "PropertySearch",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v49/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "propertySearchDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tenant",
        "kind": "LinkedField",
        "name": "tenantSettings",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "propertySearch",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "organisation",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Subscription",
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhoneNumber",
                    "kind": "LinkedField",
                    "name": "phoneNumbers",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "number",
                        "storageKey": null
                      },
                      (v56/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Email",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v56/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "broker",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v51/*: any*/),
                      (v50/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/)
            ],
            "type": "PropertySearch",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v49/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e2f8930f52e396012ed8dbc191f923e8",
    "id": null,
    "metadata": {},
    "name": "propertySearchDrawerQuery",
    "operationKind": "query",
    "text": "query propertySearchDrawerQuery(\n  $id: ID!\n) {\n  tenantSettings {\n    defaultMapCoordinates {\n      lng\n      lat\n      z\n    }\n    id\n  }\n  propertySearch: node(id: $id) {\n    __typename\n    ... on PropertySearch {\n      id\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n        ...userSummary_user\n      }\n      places {\n        id\n        type\n        objectId\n        lat\n        lng\n        label\n        population\n        breadcrumbs(incudeNonIndexed: true) {\n          id\n        }\n      }\n      offerType\n      salePriceLte\n      salePriceGte\n      monthlyRentLte\n      monthlyRentGte\n      propertyUsage\n      propertyStatuses\n      numberOfRoomsGte\n      numberOfRoomsLte\n      numberOfBedroomsGte\n      numberOfBedroomsLte\n      numberOfBathroomsGte\n      numberOfBathroomsLte\n      livingSurfaceGte\n      livingSurfaceLte\n      builtSurfaceGte\n      builtSurfaceLte\n      landSurfaceGte\n      landSurfaceLte\n      propertyTypes {\n        id\n        label\n        mainType\n      }\n      propertyMainTypeIn\n      hasSwimmingPool\n      hasLift\n      hasParking\n      hasGarden\n      hasBalcony\n      hasView\n      notification\n      activateAggregator\n      comment\n      source\n      canEditAlerts\n    }\n    id\n  }\n  propertyTypes(includeHidden: true) {\n    id\n    name\n    label\n    mainType\n    type\n  }\n}\n\nfragment userAvatar_user on User {\n  id\n  firstName\n  lastName\n  primaryImage {\n    url\n    id\n  }\n  primaryEmail {\n    email\n    id\n  }\n  referrer\n  isBroker\n  isAdmin\n}\n\nfragment userSummary_user on User {\n  ...userAvatar_user\n  id\n  displayName\n  organisation {\n    id\n    name\n  }\n  phoneNumbers {\n    formattedNumber\n    number\n    primary\n    id\n  }\n  emails {\n    email\n    primary\n    id\n  }\n  broker {\n    ...userAvatar_user\n    id\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2d1dddc3778ac60f4b4bbc7b2a465ed";

export default node;
